export const sellerLeadFrequentlyAskedQuestions = [
  {
    title: "What types of businesses can benefit from the Seller Leads product?",
    content: "The Seller Leads product is designed for e-commerce service providers, marketing agencies, software providers, freight forwarders, and other businesses looking to connect with Amazon sellers and provide services tailored to their needs."
  },
  {
    title: "How does the Advanced Seller Search feature work?",
    content: "The Advanced Seller Search feature allows you to filter through our database of 5 million Amazon sellers using various attributes such as seller rank, top categories, top brands, review history, competitors, seller location, and other metrics. This helps you create a customized list of leads that fit your target criteria."
  },
  {
    title: "Do you provide lead list generation customized to specific customer needs?",
    content: "Yes, we have worked with a variety of customer needs for lead list sizes ranging from 1,000 to 35,000. Our flexible platform allows us to tailor lead lists according to your unique requirements."
  },
  {
    title: "Does TrackSellers provide extensive contact information for sellers in the Seller Leads product?",
    content: "TrackSellers offers a wealth of contact data for most Amazon sellers in our database, including various contact details and company information. This comprehensive contact information enables you to reach out to prospective leads through multiple channels and establish a more personalized connection."
  },
  {
    title: "How many leads can I generate per month with TrackSellers' Seller Leads product?",
    content: "With our Seller Leads product, you can generate leads at any scale, ranging from 100 to 10,000 or more per month or more, depending on your business requirements and subscription plan."
  },
  {
    title: "Can I export my lead lists from TrackSellers?",
    content: "Yes, you can export your customized lead lists from TrackSellers in various formats, such as CSV or Excel, for easy integration with your CRM or other business tools."
  },
  {
    title: "How do I ensure the leads generated are relevant to my business?",
    content: "Our Advanced Seller Search feature allows you to filter leads based on specific attributes that are relevant to your business, ensuring that you only connect with sellers who are likely to be interested in your services."
  },
  {
    title: "Can I integrate TrackSellers' Seller Leads product with my CRM or other business tools?",
    content: "Yes, you can easily integrate the exported lead lists with your CRM or other business tools, allowing you to seamlessly manage and nurture your leads within your existing workflow."
  },
  {
    title: "Are there any restrictions on how I can use the data provided by TrackSellers' Seller Leads product?",
    content: "As a user of the Seller Leads product, you must adhere to our terms of service and applicable data protection laws. We encourage you to use the data responsibly and ethically when reaching out to potential leads."
  }

]
